/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [

  {
    header: 'Настройки компании',
    items: [
      {
        url: '/company',
        name: 'Компания',
        slug: 'Компания',
        icon: 'HomeIcon',
        permission: 'company.show'
      },
      {
        url: '/operators',
        name: 'Операторы',
        slug: 'Операторы',
        icon: 'UserIcon',
        permission: 'company.operator.list'
      },
      {
        url: '/groups',
        name: 'Группы Операторов',
        slug: 'Группы Операторов',
        icon: 'UsersIcon',
        permission: 'company.manage'
      },
      {
        url: '/reports',
        name: 'Отчетность',
        slug: 'Отчетность',
        icon: 'BarChart2Icon',
        permission: 'report.manage'

      }
    ]
  },
  {
    header: 'Каналы общения',
    items: [
      {
        url: '/channels',
        name: 'Каналы общения',
        slug: 'Каналы общения',
        icon: 'GridIcon',
        permission: 'company.channel.list'
      },
      {
        url: '/scenarios',
        name: 'Сервисное меню',
        slug: 'Сервисное меню',
        icon: 'LayoutIcon',
        permission: 'company.manage'
      },
      {
        url: '/widgets',
        name: 'Виджеты',
        slug: 'Создать рассылку',
        icon: 'TabletIcon',
        permission: 'widget.manage'
      }
    ]
  },
  {
    header: 'Клиенты',
    id: 'clients',
    items: [
      {
        url: '/clients',
        name: 'Клиенты',
        slug: 'Клиенты',
        icon: 'CopyIcon'
      },
      {
        id: 'chats',
        url: '/chats',
        name: 'Чаты',
        slug: 'Чаты',
        icon: 'MessageSquareIcon',
        tag: 0,
        tagColor: 'primary'
      }
    ]
  },
  {
    header: 'Рассылки',
    id: 'bulk-delivery',
    items: [
      {
        url: '/bulk-delivery/tasks/add',
        name: 'Создать рассылку',
        slug: 'Создать рассылку',
        icon: 'EditIcon',
        permission: 'bulk_delivery.manage'
      },
      {
        url: '/bulk-delivery/tasks',
        name: 'Рассылки',
        slug: 'Рассылки',
        icon: 'TabletIcon',
        permission: 'bulk_delivery.manage'
      }
    ]
  },
  {
    header: 'Дополнительно',
    items: [
      {
        url: 'https://sites.google.com/tapir.ws/faq-yolker',
        name: 'FAQ',
        icon: 'HelpCircleIcon',
        slug: 'external',
        target: '_blank'
      }
    ]
  }

]
